export default {
  METRIC: 'metric',
  IMPERIAL: 'imperial',
  METRIC_EU: 'metric_eu',
};
